import { gql } from '@apollo/client';

export const CompleteOrganizationOwnerInvitation = gql`
  mutation CompleteOrganizationOwnerInvitation($token: String!) {
    completeOrganizationOwnerInvitation(token: $token)
  }
`;
